var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDesktop30(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5 18V6a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v12H5zm10 4.003a1.004 1.004 0 0 1 0-2.006 1.004 1.004 0 0 1 0 2.006zM5 3C4 3 3 4 3 5v17c0 1 1 2 2 2h8.002v2H10.5c-.307 0-.5.224-.5.5a.5.5 0 0 0 .5.5h9a.5.5 0 1 0 0-1h-2.502v-2H25c1 0 2-1 2-2V5c0-1-1-2-2-2H5z",
    clipRule: "evenodd"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiPjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTUgMThWNmExIDEgMCAwIDEgMS0xaDE4YTEgMSAwIDAgMSAxIDF2MTJINXptMTAgNC4wMDNhMS4wMDQgMS4wMDQgMCAwIDEgMC0yLjAwNiAxLjAwNCAxLjAwNCAwIDAgMSAwIDIuMDA2ek01IDNDNCAzIDMgNCAzIDV2MTdjMCAxIDEgMiAyIDJoOC4wMDJ2MkgxMC41Yy0uMzA3IDAtLjUuMjI0LS41LjVhLjUuNSAwIDAgMCAuNS41aDlhLjUuNSAwIDEgMCAwLTFoLTIuNTAydi0ySDI1YzEgMCAyLTEgMi0yVjVjMC0xLTEtMi0yLTJINXoiIGNsaXAtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==";
export { SvgDesktop30 as ReactComponent };